import React, { useEffect } from "react";    
import { Routes, Route } from "react-router-dom";    
import { VideosProvider } from "./VideoContext";    
import { ShortsProvider } from "./Components/ShortsContext";    
import SearchPage from "./Components/SearchPage";    
import HomePage from "./Components/HomePage";    
import PageVideo from "./Permanent/PageVideo";    
import Short from "./Components/Short";    
import Feedback from "./Components/Feedback";    
import { VitStraAIWithProvider } from "./Components/VitStraAI";    
import Footer from "./Components/Footer";    
import Latest from "./Recent/latest";    
import VideoPage from "./Components/Videopage";    
import HistoryPage from "./Components/HistoryPage";    
import "./App.css";    
    
function App() {    
  const MemoShorts = Short; // do NOT memoize here, keep direct reference    
    
  // Prevent right-click (existing behavior)    
  useEffect(() => {    
    const prevent = (e) => e.preventDefault();    
    document.addEventListener("contextmenu", prevent);    
    return () => document.removeEventListener("contextmenu", prevent);    
  }, []);    
    
  return (    
    <VideosProvider>    
      <ShortsProvider>    
        <div className="app-container">    
          <Routes>    
            <Route path="/videos" element={<HomePage />} />    
            <Route path="/video/:id" element={<VideoPage />} />    
            <Route path="/feedback" element={<Feedback />} />    
            <Route path="/search" element={<SearchPage />} />    
            <Route path="/latest" element={<Latest />} />    
            <Route path="/page-video" element={<PageVideo />} />    
            <Route path="/history" element={<HistoryPage />} />    
            <Route path="/" element={<MemoShorts />} />    
            <Route path="/ai" element={<VitStraAIWithProvider />} />    
          </Routes>    
    
          <Footer isVisible={true} />    
        </div>    
      </ShortsProvider>    
    </VideosProvider>    
  );    
}    
    
export default App;